module.exports = __webpack_public_path__ + "static/img/backgroundHome3.7b38675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backgroundHome3.png
// module id = P+FG
// module chunks = 13